import { CountryCode } from '@crehana/ts-types';

import { SEOData } from '../types';

import { defaultColumns } from './default';
import { ar } from './ar';
import { ch } from './ch';
import { co } from './co';
import { es } from './es';
import { mx } from './mx';
import { pe } from './pe';
import { br } from './br';

const SEOLinksByCountry = {
  default: defaultColumns,
  ar,
  ch,
  co,
  es,
  mx,
  pe,
  br,
};

const supportedCountryCode = ['ar', 'ch', 'co', 'es', 'mx', 'pe', 'br'];

export const getSEOFooterData = (countryCode: CountryCode | null): SEOData => {
  const isSupportedCountry =
    countryCode && supportedCountryCode.includes(countryCode);

  if (isSupportedCountry && countryCode !== null) {
    // @ts-expect-error
    return SEOLinksByCountry[countryCode];
  }
  return SEOLinksByCountry.default;
};
